"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _MultipleTextInput = _interopRequireDefault(require("lead-flows-ui/components/common/MultipleTextInput"));

var _DynoLocationTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoLocationTypes"));

var _DynoLocationTypesWordpress = _interopRequireDefault(require("lead-flows-ui/constants/DynoLocationTypesWordpress"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _underscore = require("underscore");

var _default = _react.default.createClass({
  displayName: "DynoLocationSelector",
  propTypes: {
    updateWhitelistedUrls: _react.default.PropTypes.func.isRequired,
    initialWhitelistedUrls: _react.default.PropTypes.array.isRequired,
    updatePageTypesList: _react.default.PropTypes.func.isRequired,
    initialPageTypesList: _react.default.PropTypes.array.isRequired,
    helperInfo: _react.default.PropTypes.node.isRequired
  },
  getInitialState: function getInitialState() {
    var _this$props = this.props,
        initialWhitelistedUrls = _this$props.initialWhitelistedUrls,
        initialPageTypesList = _this$props.initialPageTypesList;
    var locationType;

    if (initialWhitelistedUrls.length > 0) {
      locationType = _DynoLocationTypes.default.EXACT_URL;
    } else if (initialPageTypesList.length > 0) {
      locationType = _DynoLocationTypes.default.WORDPRESS_PAGE_TYPES;
    } else {
      locationType = _DynoLocationTypes.default.ALL;
    }

    return {
      locationType: locationType,
      whitelistedUrls: initialWhitelistedUrls,
      pageTypesList: initialPageTypesList
    };
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowOptionsEditor.locationSelector." + suffix;
  },
  allPagesSelected: function allPagesSelected() {
    this.setState({
      locationType: _DynoLocationTypes.default.ALL
    });
    this.props.updateWhitelistedUrls([]);
    this.props.updatePageTypesList([]);
  },
  specificPagesSelected: function specificPagesSelected() {
    var whitelistedUrls = this.state.whitelistedUrls;
    this.setState({
      locationType: _DynoLocationTypes.default.EXACT_URL
    });
    this.props.updateWhitelistedUrls(whitelistedUrls);
    this.props.updatePageTypesList([]);
  },
  specificPagesChanged: function specificPagesChanged(whitelistedUrls) {
    this.setState({
      whitelistedUrls: whitelistedUrls
    });
    this.props.updateWhitelistedUrls(whitelistedUrls);
  },
  wordpressPageTypesSelected: function wordpressPageTypesSelected() {
    var pageTypesList = this.state.pageTypesList;
    this.setState({
      locationType: _DynoLocationTypes.default.WORDPRESS_PAGE_TYPES
    });
    this.props.updatePageTypesList(pageTypesList);
    this.props.updateWhitelistedUrls([]);
  },
  wordpressPageTypesChanged: function wordpressPageTypesChanged(pageTypesList, pageType, isChecked) {
    var newPageTypesList;

    if (isChecked) {
      newPageTypesList = pageTypesList.concat([pageType]);
    } else {
      newPageTypesList = pageTypesList.filter(function (activePageType) {
        return activePageType !== pageType;
      });
    }

    this.setState({
      pageTypesList: newPageTypesList
    });
    this.props.updatePageTypesList(newPageTypesList);
  },
  validateUrl: function validateUrl(value) {
    return (0, _ValidationUtils.isValidDynoUrl)(value, true);
  },
  getTextInputList: function getTextInputList(locationType, whitelistedUrls) {
    return _react.default.createElement(_MultipleTextInput.default, {
      textInputs: whitelistedUrls,
      isDisabled: locationType !== _DynoLocationTypes.default.EXACT_URL,
      onChange: this.specificPagesChanged,
      addTextMessage: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('addAnotherPage')
      }),
      validateInput: this.validateUrl,
      invalidInputText: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('enterValidUrl')
      })
    });
  },
  maybeRenderWordpressPageTypes: function maybeRenderWordpressPageTypes(locationType, pageTypesList, activePageTypesList) {
    var _this = this;

    var component;

    if (activePageTypesList.length > 0) {
      var checkboxes = (0, _underscore.map)(pageTypesList, function (pageType) {
        return _react.default.createElement("div", {
          key: pageType,
          className: locationType !== _DynoLocationTypes.default.WORDPRESS_PAGE_TYPES ? 'dyno-location-selector__input-disabled' : ''
        }, _react.default.createElement(_UICheckbox.default, {
          defaultChecked: (0, _underscore.contains)(activePageTypesList, pageType),
          onChange: function onChange(_ref) {
            var checked = _ref.target.checked;
            return _this.wordpressPageTypesChanged(activePageTypesList, pageType, checked);
          },
          disabled: locationType !== _DynoLocationTypes.default.WORDPRESS_PAGE_TYPES
        }, _react.default.createElement("span", {
          className: "dyno-location-selector__checkbox-label"
        }, pageType)));
      });
      component = _react.default.createElement("div", {
        className: "dyno-location-selector__radio-container"
      }, _react.default.createElement(_UIAlert.default, {
        className: "m-bottom-4 m-top-4",
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('pageTypeDeprecationTitle')
        }),
        type: "warning"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('pageTypeDeprecationBody')
      })), _react.default.createElement(_UIRadioInput.default, {
        name: "location",
        onChange: this.wordpressPageTypesSelected,
        checked: locationType === _DynoLocationTypes.default.WORDPRESS_PAGE_TYPES,
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('onlyWordPressTemplates')
        })
      }), checkboxes);
    }

    return component;
  },
  renderHelperContent: function renderHelperContent(helperInfo) {
    return _react.default.createElement(_UITooltip.default, {
      placement: "right",
      title: helperInfo
    }, _react.default.createElement(_UIIcon.default, {
      name: "info",
      className: "dyno-editor-header__helper private-form__help-tooltip"
    }));
  },
  render: function render() {
    var helperInfo = this.props.helperInfo;
    var _this$state = this.state,
        locationType = _this$state.locationType,
        whitelistedUrls = _this$state.whitelistedUrls,
        pageTypesList = _this$state.pageTypesList;
    var textList = this.getTextInputList(locationType, whitelistedUrls);
    var maybeWordpressPageTypes = this.maybeRenderWordpressPageTypes(locationType, Object.values(_DynoLocationTypesWordpress.default || {}), pageTypesList);
    var tooltip = this.renderHelperContent(helperInfo);
    return _react.default.createElement("div", {
      className: "dyno-location-selector"
    }, _react.default.createElement(_UIRadioInput.default, {
      name: "location",
      onChange: this.allPagesSelected,
      checked: locationType === _DynoLocationTypes.default.ALL,
      text: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('allPages')
      })
    }), _react.default.createElement("div", null, _react.default.createElement("label", null, _react.default.createElement(_UIRadioInput.default, {
      name: "location",
      onChange: this.specificPagesSelected,
      checked: locationType === _DynoLocationTypes.default.EXACT_URL,
      text: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('pagesMatchExactly')
      })
    }), _react.default.createElement(_Small.default, {
      use: "help",
      className: "m-x-2"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('wildcardSupported')
    })), tooltip), locationType === _DynoLocationTypes.default.EXACT_URL && textList), maybeWordpressPageTypes);
  }
});

exports.default = _default;
module.exports = exports.default;